module.exports = __webpack_public_path__ + "static/media/talentIcon.40cbd419.svg";